import { euroToKnExchangeRate, euroStartPaymentDate } from "../Config/Consts";

export const euroToKnConverter = (value) => {
  return Math.round(value * euroToKnExchangeRate * 100) / 100;
};
export const knToEuroConverter = (value) => {
  return Math.round((value / euroToKnExchangeRate) * 100) / 100;
};

export const activeCurrencyByDate = (value) => {
  if (value <= "2023-01-01T00:00:00") return "HRK";
  return "EUR";
};
